import { getApiClient } from './api';

// GET /tenants - returns the logged-in tenant's branding (theme + assets).
// Requires the Authorization header to be set (see setAuthAccessToken).
const getTenant = async () => {
  try {
    const api = getApiClient();
    const res = await api({
      method: 'GET',
      url: '/tenants',
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

// PATCH /tenants - update the logged-in tenant's branding (SUPER_ADMIN).
// payload e.g. { assets: { logoBase64, faviconBase64 }, brandName, theme }
const updateTenant = async (payload) => {
  try {
    const api = getApiClient();
    const res = await api({
      method: 'PATCH',
      url: '/tenants',
      data: payload,
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

export { getTenant, updateTenant };
